import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Breadcrumb } from "~/types/breadcrumbs";
import { RootState } from "../store/store";

// Define a type for the slice state
interface GeneralState {
  title: string;
  navMenuOpen: boolean;
  selectedNavCollapse?: string;
  breadcrumbs?: Breadcrumb[];
  isMobile?: boolean;
  headerVisible?: boolean;
}

// Define the initial state using that type
const initialState: GeneralState = {
  title: "",
  navMenuOpen: false,
  selectedNavCollapse: undefined,
  breadcrumbs: undefined,
  isMobile: undefined,
  headerVisible: undefined,
};

export const generalSlice = createSlice({
  name: "general",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setTitle: (state, action: PayloadAction<string | Breadcrumb[]>) => {
      if (typeof action.payload === "string") {
        state.title = action.payload;
        state.breadcrumbs = undefined;
      } else {
        state.breadcrumbs = action.payload;
      }
    },
    setNavMenuOpen: (state, action: PayloadAction<boolean>) => {
      state.navMenuOpen = action.payload;
    },
    setSelectedNavCollapse: (state, action: PayloadAction<string>) => {
      state.selectedNavCollapse = action.payload;
    },
    setIsMobile: (state, action: PayloadAction<boolean>) => {
      state.isMobile = action.payload;
    },
    setHeaderVisible: (state, action: PayloadAction<boolean>) => {
      state.headerVisible = action.payload;
    },
  },
});

export const {
  setTitle,
  setNavMenuOpen,
  setSelectedNavCollapse,
  setIsMobile,
  setHeaderVisible,
} = generalSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectTitle = (state: RootState): string => state.general.title;

export default generalSlice.reducer;
